import { FilterName } from 'types/enums';
import { ApiFilter } from 'contexts/ApiFiltersContext/types';
import { SearchFilterMeta } from 'controllers/SearchController/types';
import { BaseMeta } from 'types';
import { ListOfItems } from '../types';

export interface List<T = string> extends BaseMeta<T> {
    subInstruments?: BaseMeta[];
    subGenres?: BaseMeta[];
    subSfxs?: BaseMeta[];
}

const getListOfItems = <T extends List>({
    apiFilters,
    filterName,
    searchFilterMeta,
    isReversed = false,
    subKey,
}: {
    apiFilters?: ApiFilter[];
    filterName: FilterName;
    searchFilterMeta?: SearchFilterMeta;
    isReversed?: boolean;
    subKey?: 'subInstruments' | 'subGenres' | 'subSfxs';
}): ListOfItems => {
    const filter = apiFilters?.find((filters) => filters.name === filterName);

    if (!filter || !searchFilterMeta) {
        return { list: [], name: '' };
    }

    const { name, list } = filter;

    const listItem = list.map((list) => ({
        code: list.code,
        numberOfResults: searchFilterMeta[list.code],
        list:
            subKey &&
            (list as T)[subKey]?.map((item) => {
                return {
                    code: item.code,
                    numberOfResults: searchFilterMeta[item.code],
                };
            }),
    }));

    const listItemReordered = isReversed ? listItem.reverse() : listItem;

    return { list: listItemReordered, name };
};

export default getListOfItems;
